/**
 * App Navbar - Top Navigation Bar
 */

import { ChefHat, Bell, Download, HelpCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { SidebarTrigger } from "./ui/sidebar";
import { ThemeSwitcher } from "./ThemeSwitcher";
import { UserNav } from "./UserNav";
import { Separator } from "./ui/separator";
import { Button } from "./ui/button";
import { usePWA } from "@/hooks/usePWA";
import { toast } from "sonner";

export function AppNavbar() {
  const { promptInstall, isInstallable } = usePWA();

  const handleInstall = async () => {
    if (!isInstallable) {
      toast.info("Este app já está instalado ou seu navegador não suporta instalação");
      return;
    }

    try {
      const accepted = await promptInstall();
      if (accepted) {
        toast.success("App instalado com sucesso! 🎉");
      } else {
        toast.info("Instalação cancelada");
      }
    } catch (error) {
      console.error("Erro ao instalar:", error);
      toast.error("Não foi possível instalar o app");
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-14 items-center gap-4 px-4">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="h-6" />

        <div className="flex items-center gap-2">
          <ChefHat className="h-5 w-5 text-primary" />
          <span className="font-semibold text-lg hidden sm:inline-block">Pudinzim Sorocaba</span>
        </div>

        <div className="flex-1" />

        <div className="flex items-center gap-2">
          <Button 
            variant="ghost" 
            size="sm"
            className="h-9 gap-2"
            aria-label="Instalar aplicativo"
            onClick={handleInstall}
          >
            <Download className="h-4 w-4" />
            <span className="text-sm font-medium">Baixar App</span>
          </Button>

          <Button 
            variant="ghost" 
            size="icon"
            className="h-9 w-9"
            aria-label="Central de Ajuda"
            asChild
          >
            <Link to="/ajuda">
              <HelpCircle className="h-4 w-4" />
              <span className="sr-only">Ajuda</span>
            </Link>
          </Button>

          <div className="relative">
            <Button 
              variant="ghost" 
              size="icon" 
              className="h-9 w-9"
              aria-label="Notificações"
            >
              <Bell className="h-4 w-4" />
              <span className="sr-only">Notificações</span>
            </Button>
            {false && (
              <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-red-500" />
            )}
          </div>

          <ThemeSwitcher />
          <UserNav />
        </div>
      </div>
    </header>
  );
}
